import React, { Component } from 'react';
import { decorate, observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import _ from "underscore";

import './style.scss';
import categoryCode from './categoryCode';

import PageTitle from "../../../components/common/PageTitle";
import ModalLoading from "../../../components/common/ModalLoading";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import FeatherIcon from 'feather-icons-react';
import {
    Form,
    FormGroup,
    FormInput,
    FormSelect,
    Button,
    Card,
    CardBody,
    CardHeader,
    Collapse,
    Row,
    Col,
    Container,
    Badge,
    InputGroup,
    InputGroupAddon,
    FormRadio,
    FormCheckbox, FormTextarea
} from "shards-react";
import {Link} from "react-router-dom";
import productList from "../../../images/label/product_list.png";
import viewer from "../../../images/label/viewer.png";
import writer from "../../../images/label/writer.png";
import reviewable_list from "../../../images/label/reviewable_list.png";


const labelData = {
    common: {
        review: "리뷰",
        ratingNum: "평점",
        latest: "최신순",
        recommended: "추천순",
        rating: "평점순",
        helpful: "도움돼요",
        comments: "댓글",
        btnWriteReviewBtn: "리뷰 작성",
        pre: "이전",
        next: "다음",
        close: "닫기",
        btnAttachMedia: "사진/영상 첨부하기",
        submit: "등록",
        rating_1: "최고예요",
        rating_2: "좋아요",
        rating_3: "보통이에요",
        rating_4: "그저 그래요",
        rating_5: "별로예요",
        manager: "관리자",
        orderAt: "주문일",
    },
    productList: {
        title: "REVIEW",
        btnWriteReview: "상품 리뷰 작성하기",
        fixReviewLabel: "쇼핑몰 추천 리뷰",
        info_1: "*** 의 구매자가 이 상품에 만족하고 있어요!",
        info_1_alt: "아직 리뷰가 없어요. 첫 리뷰를 남겨주세요!",
        info_2: "총 *** 건의 후기",
        info_3: "아직 리뷰가 없는 따끈따끈한 상품입니다.",
        titlePhoto: "포토 리뷰",
    },
    viewer: {
        title: "포토 리뷰",
    },
    writer: {
        title: "리뷰 닫기",
        productSatisfaction: "상품은 만족하셨나요?",
        deliverySatisfaction: "배송은 만족하셨나요?",
        writeLabel: "어떤 점이 좋았나요?",
        writeInfo: "리뷰를 작성해 주세요.(최소 ***자 이상)",
        btnAddMedia: "사진/동영상 첨부하기",
        info_1: "리뷰 작성 시 참고해 주세요",
        info_2: "파일 업로드 성공!",
    },
    reviewableList: {
        info_1: "상품은 어떠셨나요?",
        info_2: "***님의 리뷰를 기다리고 있어요!",
    },
    alert: {
        alreadyReviewed:      "이미 이 상품에 대한 리뷰를 작성하셨습니다.",
        abuseDetected:        "부정행위가 감지되어 활동이 제한됩니다.",
        duplicateReviewExists:"중복된 리뷰가 존재합니다.",
        invalidAccess:        "유효하지 않은 접근입니다.",
        onlyImageAllowed:     "이미지 파일만 업로드할 수 있습니다.",
        reviewWriteFailed:    "리뷰 작성에 실패했습니다. 잠시 후 다시 시도해 주세요.",
        loginRequired:        "로그인 후에 리뷰를 작성할 수 있습니다.",
        noReviewAvailable:    "작성할 수 있는 리뷰가 없습니다.",
        fileSizeExceeded:     "용량이 10MB 이하인 파일만 업로드할 수 있습니다.",
        fileSizeExceeded_1:     "용량이 30MB 이하인 파일만 업로드할 수 있습니다."
    }
}

const labelData_en = {
    common: {
        review: "Review",
        ratingNum: "Rating",
        latest: "Latest",
        recommended: "Recommended",
        rating: "Rating",
        helpful: "Helpful",
        comments: "Comments",
        btnWriteReviewBtn: "Write a Review",
        pre: "Previous",
        next: "Next",
        close: "Close",
        btnAttachMedia: "Attach Photo/Video",
        submit: "Submit",
        rating_1: "Excellent",
        rating_2: "Good",
        rating_3: "Average",
        rating_4: "So-so",
        rating_5: "Poor",
        manager: "manager",
        orderAt: "Order Date",
    },
    productList: {
        title: "REVIEW",
        btnWriteReview: "Write a Product Review",
        fixReviewLabel: "Featured Reviews",
        info_1: "*** customers are satisfied with this product!",
        info_1_alt : "There are no reviews yet. Be the first to leave a review!",
        info_2: "Total *** reviews",
        info_3 : "This is a brand-new product with no reviews yet.",
        titlePhoto: "Photo Reviews",
    },
    viewer: {
        title: "Photo Reviews",
    },
    writer: {
        title: "Close Review",
        productSatisfaction: "Are you satisfied with the product?",
        deliverySatisfaction: "Was the delivery satisfactory?",
        writeLabel: "What did you like?",
        writeInfo: "Please write a review (at least *** characters)",
        btnAddMedia: "Add Photo/Video",
        info_1: "Please refer to this when writing a review",
        info_2: "File uploaded successfully!",
    },
    reviewableList: {
        info_1: "How was the product?",
        info_2: "***, we're waiting for your review!",
    },
    alert: {
        alreadyReviewed: "You have already written a review for this product.",
        abuseDetected: "Fraudulent activity detected; your actions have been restricted.",
        duplicateReviewExists: "A duplicate review already exists.",
        invalidAccess: "Invalid access.",
        onlyImageAllowed: "Only image files can be uploaded.",
        reviewWriteFailed: "Failed to submit your review. Please try again later.",
        loginRequired: "You must be logged in to write a review.",
        noReviewAvailable: "No reviews available to post.",
        fileSizeExceeded: "You can only upload files up to 10MB.",
        fileSizeExceeded_1: "You can only upload files up to 30MB."

    }
}

const labelData_jp = {
    common: {
        review: "レビュー",
        ratingNum: "評価",
        latest: "最新順",
        recommended: "おすすめ順",
        rating: "評価順",
        helpful: "参考になった",
        comments: "コメント",
        btnWriteReviewBtn: "レビューを書く",
        pre: "前へ",
        next: "次へ",
        close: "閉じる",
        btnAttachMedia: "写真・動画を添付する",
        submit: "登録",
        rating_1: "最高です",
        rating_2: "良いです",
        rating_3: "普通です",
        rating_4: "まあまあです",
        rating_5: "よくないです",
        manager: "管理者",
        orderAt: "注文日",
    },
    productList: {
        title: "レビュー",
        btnWriteReview: "商品レビューを書く",
        fixReviewLabel: "おすすめのレビュー",
        info_1: "*** の購入者がこの商品に満足しています！",
        info_1_alt : "まだレビューがありません。最初のレビューを投稿してください！",
        info_2: "レビュー件数：*** 件",
        info_3 : "まだレビューのない、できたてホヤホヤの商品です",
        titlePhoto: "写真レビュー",
    },
    viewer: {
        title: "写真レビュー",
    },
    writer: {
        title: "レビューを閉じる",
        productSatisfaction: "商品に満足しましたか？",
        deliverySatisfaction: "配送に満足しましたか？",
        writeLabel: "どんな点が良かったですか？",
        writeInfo: "レビューを記入してください（***文字以上）",
        btnAddMedia: "写真・動画を追加",
        info_1: "レビューを書く際の参考にしてください",
        info_2: "ファイルのアップロードに成功しました！",
    },
    reviewableList: {
        info_1: "商品はいかがでしたか？",
        info_2: "*** さんのレビューをお待ちしています！",
    },
    alert: {
        alreadyReviewed: "この商品に対するレビューは既に投稿済みです。",
        abuseDetected: "不正行為が検出されたため、活動が制限されています。",
        duplicateReviewExists: "重複したレビューが存在します。",
        invalidAccess: "無効なアクセスです。",
        onlyImageAllowed: "画像ファイルのみアップロードできます。",
        reviewWriteFailed: "レビューの投稿に失敗しました。時間をおいて再度お試しください。",
        loginRequired: "レビューを書くにはログインが必要です。",
        noReviewAvailable: "投稿可能なレビューがありません。",
        fileSizeExceeded: "ファイルは10MB以下のみアップロードできます。",
        fileSizeExceeded_1: "ファイルは30MB以下のみアップロードできます。"
    }
}

// https://smartsms.aligo.in/alimapi.html
@inject(({ common }) => ({ getStoreTotalConfig: common.getStoreTotalConfig, getDoc: common.getDoc, updateDoc: common.updateDoc }))
@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me: teamUser.me }))
@inject(({ booster }) => ({ addKakaoProfile: booster.addKakaoProfile }))
@inject(({ AOA }) => ({ adminCusData:AOA.adminCusData }))

@observer
class Labeling extends Component {

    // basic
    @observable store = {};
    @observable teamUser = {};
    @observable permissions = {};
    @observable isLogin = false;
    @observable isLoading = false;



    // settings
    @observable package = "default_kr";
    @observable guideLabelData = {};
    @observable labelData = {};


    constructor(props) {
        super(props);
        this.init();
    }

    @action
    init = async () => {
        if (this.props.isLogin) {
            // basic
            this.isLogin = this.props.isLogin;
            this.teamUser = this.props.me;
            this.store = this.props.me.store ? this.props.me.store : {};
            this.permissions = this.props.me.permissions;


            // Load settings
            await this.copyCommonData(this.package);
            await this.getSettings();

        }
    };

    @action
    copyCommonData = async (selPackage) => {

        let targetLabes;
        switch (selPackage) {
            case "default_kr":
                targetLabes = labelData;
                break;
            case "default_en" :
                targetLabes = labelData_en;
                break;
            case "default_jp":
                targetLabes = labelData_jp;
                break;
            default:
                targetLabes = labelData;
                break;
        }

        const commonData = targetLabes.common;
        Object.keys(targetLabes).forEach(key => {
            if (key !== 'common' && key !== 'alert') {
                this.labelData[key] = _.clone(_.defaults({}, targetLabes[key], commonData));
                this.guideLabelData[key] = _.clone(_.defaults({}, targetLabes[key], commonData));
            }
            else if(key === 'alert') {
                this.labelData.alert = _.clone(targetLabes.alert);
                this.guideLabelData.alert = _.clone(targetLabes.alert);
            }
            else {
                this.labelData.common = _.clone(commonData);
                this.guideLabelData.common = _.clone(commonData);
            }
        });
    };


    @action
    getSettings = async () => {
        let _this = this;
        this.isLoading = true;
        this.props.getStoreTotalConfig({store_id: this.teamUser.selStore_id, shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1}, function(res) {
            if(res.labels && res.labels.labels) {
                Object.entries(_this.labelData).map(([key, value], index) => {
                    _this.labelData[key].map((item, index) => {
                        _this.labelData[key][item] = res.labels.labels[key][item];
                    })
                });

                //_this.labelData = res.labels.labels;
            }
            // else {
            //     _this.labelData = labelData;
            // }
        })

        // 설정 값 처리 후 아래 코드 삭제
        this.isLoading = false;
    };

    @action
    saveLables = async () => {
        this.isLoading = true;

        const params = {
            store_id: this.teamUser.selStore_id,
            shopNo: this.teamUser.selShopNo || 1,
            labels: this.labelData,
        };

        await this.props.updateDoc('updateLabels', params, (res) => {
            if (res.errors && res.errors.length > 0) {
                toast(res.errors[0].message);
            } else {
                toast("설정이 저장되었습니다.");
            }
            this.isLoading = false;
        });
    };

    // @action
    // onToggleChange = (section) => {
    //
    // };
    //
    // @action
    // onRadioChange = (event, targetData, valType) => {
    //     const { name, value } = event.target;
    //     targetData[name] = valType === "int" ?  parseInt(value) : value;
    //     console.log(value, name);
    // };

    @action
    onInputChange = (event, target) => {
        const { value, name } = event.target;
        target[name] = value;
    };

    // @action
    // onChangeChecked = async (event, targetObj, keyArray) => {
    //     if(keyArray[0]) {
    //         targetObj[keyArray[0]] = !targetObj[keyArray[0]];
    //     }
    // };

    @action
    onChangeLangSelcter = async (event, targetData) => {
        const { value, name } = event.target;
        let confirmCheck = window.confirm("패키지를 변경하면 기존에 편집하신 라벨들이 모두 사라질 수 있습니다. 변경을 진행하시겠습니까?");
        if (confirmCheck) {
            targetData[name] = value;
            this.copyCommonData(value);
        }

    };



    // @action
    // onChangeStep = async (stepNo) => {
    //     let _this = this;
    // };



    render() {
        return (
            <div className="main-content">
                <PageTitle />
                {( this.isLogin && this.teamUser.emailId && this.labelData.common ) ? (

                    <div className="setting-box labeling-setting-box">
                        <Row>
                            <Col lg="12">
                                <Card className="mb-4">
                                    <CardHeader className="bg-light">
                                        <h5 className="m-0">라벨/언어 패키지</h5>
                                    </CardHeader>
                                    <CardBody>
                                        <Row>
                                            <FormSelect name="package"
                                                        value={this.package}
                                                        onChange={event => {this.onChangeLangSelcter(event, this)}}
                                                        className="search-type">
                                                <option value="default_kr">기본 한국어</option>
                                                <option value="default_jp">일본어</option>
                                                <option value="default_en">영어</option>
                                            </FormSelect>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="12">
                                <Card className="mb-4">
                                    <CardHeader className="bg-light">
                                        <h5 className="m-0">공통 라벨</h5>
                                    </CardHeader>
                                    <CardBody>
                                        <Row>
                                            {this.guideLabelData.common ? Object.entries(this.guideLabelData.common).map(([key, value], index) => (
                                                <Col lg="4" key={index}>
                                                    <div className="d-flex align-items-center mb-3">
                                                        <span className="mr-3">{labelData.common[key]}</span>
                                                        <FormInput
                                                            placeholder={value}
                                                            name={key}
                                                            value={this.labelData.common[key]}
                                                            onChange={event => {
                                                                this.onInputChange(event, this.labelData.common)
                                                            }}
                                                            className="mr-2"
                                                        />
                                                    </div>
                                                </Col>
                                            )) : null}
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="5">
                                <Card className="mb-4">
                                    <CardHeader className="bg-light">
                                        <h5 className="m-0">기본 상품 상세</h5>
                                    </CardHeader>
                                    <CardBody>
                                        {Object.entries(this.guideLabelData.productList).map(([key, value], index) => {
                                            if (key === 'common' && value.length > 0) {
                                                return (<div></div>);
                                            }
                                            else {
                                                return (
                                                    <div className="d-flex align-items-center mb-3" key={index}>
                                                        <span className="mr-3">{labelData.productList[key] ? labelData.productList[key] : labelData.common[key]}</span>
                                                        <FormInput
                                                            placeholder={value}
                                                            name={key}
                                                            value={this.labelData.productList[key]}
                                                            onChange={event => {
                                                                this.onInputChange(event, this.labelData.productList)
                                                            }}
                                                            className="mr-2"
                                                        />
                                                    </div>
                                                )
                                            }
                                        })}
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col lg="7">
                                <Card className="mb-4">
                                    <CardHeader className="bg-light">
                                        <h5 className="m-0">[기본 상품 상세] 미리보기</h5>
                                    </CardHeader>
                                    <CardBody>
                                        <img src={productList} />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="5">
                                <Card className="mb-4">
                                    <CardHeader className="bg-light">
                                        <h5 className="m-0">리뷰 보기</h5>
                                    </CardHeader>
                                    <CardBody>
                                        {Object.entries(this.guideLabelData.viewer).map(([key, value], index) => {
                                            if (key === 'common' && value.length > 0) {
                                                return (<div></div>);
                                            }
                                            else {
                                                return (
                                                    <div className="d-flex align-items-center mb-3" key={index}>
                                                        <span className="mr-3">{labelData.viewer[key] ? labelData.viewer[key] : labelData.common[key]}</span>
                                                        <FormInput
                                                            placeholder={value}
                                                            name={key}
                                                            value={this.labelData.viewer[key]}
                                                            onChange={event => {
                                                                this.onInputChange(event, this.labelData.viewer)
                                                            }}
                                                            className="mr-2"
                                                        />
                                                    </div>
                                                )
                                            }
                                        })}
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col lg="7">
                                <Card className="mb-4">
                                    <CardHeader className="bg-light">
                                        <h5 className="m-0">[리뷰 보기] 미리보기</h5>
                                    </CardHeader>
                                    <CardBody>
                                        <img src={viewer} />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="5">
                                <Card className="mb-4">
                                    <CardHeader className="bg-light">
                                        <h5 className="m-0">리뷰 작성</h5>
                                    </CardHeader>
                                    <CardBody>
                                        {Object.entries(this.guideLabelData.writer).map(([key, value], index) => {
                                            if (key === 'common' && value.length > 0) {
                                                return (<div></div>);
                                            }
                                            else {
                                                return (
                                                    <div className="d-flex align-items-center mb-3" key={index}>
                                                        <span className="mr-3">{labelData.writer[key] ? labelData.writer[key] : labelData.common[key]}</span>
                                                        <FormInput
                                                            placeholder={value}
                                                            name={key}
                                                            value={this.labelData.writer[key]}
                                                            onChange={event => {
                                                                this.onInputChange(event, this.labelData.writer)
                                                            }}
                                                            className="mr-2"
                                                        />
                                                    </div>
                                                )
                                            }
                                        })}
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col lg="7">
                                <Card className="mb-4">
                                    <CardHeader className="bg-light">
                                        <h5 className="m-0">[리뷰 작성] 미리보기</h5>
                                    </CardHeader>
                                    <CardBody>
                                        <img src={writer} />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="5">
                                <Card className="mb-4">
                                    <CardHeader className="bg-light">
                                        <h5 className="m-0">작성유도위젯</h5>
                                    </CardHeader>
                                    <CardBody>
                                        {Object.entries(this.guideLabelData.reviewableList).map(([key, value], index) => {
                                            if (key === 'common' && value.length > 0) {
                                                return (<div></div>);
                                            }
                                            else {
                                                return (
                                                    <div className="d-flex align-items-center mb-3" key={index}>
                                                        <span className="mr-3">{labelData.reviewableList[key] ? labelData.reviewableList[key] : labelData.common[key]}</span>
                                                        <FormInput
                                                            placeholder={value}
                                                            name={key}
                                                            value={this.labelData.reviewableList[key]}
                                                            onChange={event => {
                                                                this.onInputChange(event, this.labelData.reviewableList)
                                                            }}
                                                            className="mr-2"
                                                        />
                                                    </div>
                                                )
                                            }
                                        })}
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col lg="7">
                                <Card className="mb-4">
                                    <CardHeader className="bg-light">
                                        <h5 className="m-0">[작성유도위젯]미리보기</h5>
                                    </CardHeader>
                                    <CardBody>
                                        <img src={reviewable_list} />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="12">
                                <Card className="mb-4">
                                    <CardHeader className="bg-light">
                                        <h5 className="m-0">경고(알림) 메시지</h5>
                                    </CardHeader>
                                    <CardBody>
                                        <Row>
                                            {this.guideLabelData.alert && this.labelData.alert ? Object.entries(this.guideLabelData.alert).map(([key, value], index) => (
                                                <Col lg="12" key={index}>
                                                    <div className="d-flex align-items-center mb-3">
                                                        <span className="mr-3">{labelData.alert[key]}</span>
                                                        <FormInput
                                                            placeholder={value}
                                                            name={key}
                                                            // value={this.labelData.alert[key]}
                                                            onChange={event => {
                                                                // this.onInputChange(event, this.labelData.alert)
                                                            }}
                                                            className="mr-2"
                                                        />
                                                    </div>
                                                </Col>
                                            )) : null}
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row className="pb-5 text-right">
                            <Col lg="12"><Button size="lg" onClick={event => this.saveLables()}>저장하기</Button></Col>
                        </Row>

                    </div>
                    ) :
                    null
                }

                <ModalLoading isLoading={this.isLoading} />
            </div>
        );
    }
}

export default Labeling;